/* Pufa Bundle — emphasize the "מתנה: כולל N קפסולות חינם" gift line in the cart.
   The Essential cart drawer renders with build-hashed classes (no stable CSS hook),
   so we match the gift note by its (stable) text and bold it. Cosmetic + fails safe:
   if nothing matches, nothing happens. Re-applies on every drawer re-render. */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var ACCENT = '#c70d38';

  // A leaf element whose text reads "...כולל ... חינם" is our gift-note value.
  function isGiftNote(el) {
    if (el.children.length) return false;
    if (el.getAttribute('data-pbb-gift') === '1') return false;
    var t = el.textContent || '';
    return t.indexOf('כולל') > -1 && t.indexOf('חינם') > -1;
  }

  function emphasize() {
    var els = document.querySelectorAll('dd,div,span,p,li');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!isGiftNote(el)) continue;
      el.setAttribute('data-pbb-gift', '1');
      el.style.fontWeight = '700';
      el.style.color = ACCENT;
      // Bold the row so the "מתנה:" label matches the value.
      if (el.parentElement) {
        el.parentElement.style.fontWeight = '700';
        el.parentElement.style.color = ACCENT;
      }
    }
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(emphasize, 120); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* no observer — initial pass still ran */ }
})();
